<template>
  <b-row align-v="center" class="info-icon text-base text-14">
    <img src="@/assets/info-circle.svg" alt="info" width="16px" style="filter: invert(1);">
    <span class="ml-1">{{ info }}</span>
  </b-row>
</template>

<script>
export default {
  props: [
    'info'
  ]
}
</script>

<style>
  .info-icon {
    background-color: #0BA7DA;
    border-radius: 5px;
    padding: 4px;
    box-shadow: #00000008 0 0 6px 0;
    max-width: fit-content;
    color: white;
  }
</style>
